import { Stack } from "@mui/material";
import cn from "classnames";
import "./styles.scss";

export const Spacer = () => {
  return <div className="spacer" />;
};

export const ResponsiveFormStack = ({
  children,
  className,
  legacy = false,
}) => {
  return (
    <div
      className={cn("responsive-form-stack", className, {
        "responsive-form-stack-legacy": legacy,
      })}
    >
      {children}
    </div>
  );
};

export const Column = ({ children, className, spacing }) => {
  return (
    <Stack
      className={cn("column", className)}
      direction="column"
      sx={{
        gap: `${spacing}px`,
      }}
    >
      {children}
    </Stack>
  );
};
